import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { QueryKeyConfig } from '../../api/api-helper';
import { SelectItem } from './select-item.component';
import { AutoCompleteSelectItem } from './autocomplete-select-item.component';
import ReplayIcon from '@mui/icons-material/Replay';

export interface SelectResult {
  [key: string]: any;
}

export interface SelectConfig {
  title: string;
  optionsValueKey: string;
  optionsLabelKey: string;
  disabled?: boolean;
  error?: string;
  getQueryKeyConfig: (data?: SelectResult) => QueryKeyConfig;
  type?: 'select' | 'autocomplete';
}

interface SelectChainFilterProps {
  value: SelectResult;
  config: SelectConfig[];
  onSelect: (selectedValue: SelectResult) => void;
  onHandleRefreshClick?: () => void;
  isRefreshVisible?: boolean;
  isDisabled?: boolean;
}

export const SelectChainItem = ({
  value,
  config,
  onSelect,
  onHandleRefreshClick,
  isRefreshVisible,
  isDisabled,
}: SelectChainFilterProps) => {
  const handleFilterSelected = (filter: SelectResult, index: number) => {
    // TODO - Optimize this logic
    const data = config.reduce((result: any, config: SelectConfig, i: number) => {
      if (i < index) {
        return {
          ...result,
          [config.optionsValueKey]: value[config.optionsValueKey],
        };
      }
      return result;
    }, {});

    onSelect({ ...data, ...filter });
  };

  const handleRefreshClick = () => {
    onHandleRefreshClick?.();
  };

  return (
    <Grid container spacing={1}>
      {config.map((c, index) => (
        <Grid item lg={3} sm={3} xl={3} xs={6} key={c.optionsValueKey}>
          {c.type === 'autocomplete' ? (
            <>
              <AutoCompleteSelectItem
                key={c.optionsValueKey}
                config={c}
                value={value}
                disabled={c.disabled}
                onSelect={(filter: SelectResult) => handleFilterSelected(filter, index)}
              />
              {c?.error && <label className="errorMsg">{c?.error}</label>}
            </>
          ) : (
            <SelectItem
              key={c.optionsValueKey}
              config={c}
              value={value}
              onSelect={(filter: SelectResult) => handleFilterSelected(filter, index)}
            />
          )}
        </Grid>
      ))}
      {isRefreshVisible && (
        <Tooltip title={<Typography variant="body1">Refresh</Typography>}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              disabled={!isDisabled}
              className="btn btn-primary "
              style={{ height: '39px', marginLeft: '5px', marginTop: '7px' }}
              aria-label="reload"
              onClick={handleRefreshClick}
            >
              <ReplayIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Grid>
  );
};
